import Vue from 'vue'
import VueRource from 'vue-resource'
import {API_ROOT} from '../config'

Vue.use(VueRource)

const getReflectData = (type, pageIndex, pageSize) => Vue.http.get(API_ROOT + 'Activties/GetActivityBlackList', {params: {type: type, pagesize: pageSize, pageindex: pageIndex}})
export {
  getReflectData
}



// WEBPACK FOOTER //
// ./src/api/reflectService.js